// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { LienWaiversPageLienWaiverFragmentDoc } from '../../fragments/circularFragments.generated';
import { PageInfoFragmentDoc } from '../projects/ProjectsPage.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LienWaiversPageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.LienWaiverFilter>;
  order?: Types.InputMaybe<Types.LienWaiverOrder>;
  page: Types.PageFilter;
}>;


export type LienWaiversPageQuery = { __typename?: 'Query', lienWaiversPage: { __typename?: 'LienWaiversPage', entities: Array<{ __typename?: 'LienWaiver', id: string, project:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      , parent:
        | { __typename?: 'StandaloneProject' }
        | { __typename?: 'Region' }
        | { __typename?: 'Bill', id: string, tradePartnerNumber: string }
        | { __typename?: 'Invoice' }
        | { __typename?: 'Market' }
        | { __typename?: 'Community' }
        | { __typename?: 'Subdivision' }
        | { __typename?: 'Lot' }
        | { __typename?: 'Structure' }
        | { __typename?: 'Unit' }
      , claimant:
        | { __typename?: 'Builder' }
        | { __typename?: 'TradePartner', id: string, name: string }
      , type: { __typename?: 'LienWaiverTypeDetail', code: Types.LienWaiverType, name: string }, condition: { __typename?: 'LienWaiverConditionDetail', code: Types.LienWaiverCondition, name: string }, status: { __typename?: 'LienWaiverStatusDetail', code: Types.LienWaiverStatus, name: string }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus, name: string, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, parent:
            | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                  | { __typename?: 'StandaloneProject', id: string, name: string }
                  | { __typename?: 'Region', id: string, name: string }
                  | { __typename?: 'Market', id: string, name: string }
                  | { __typename?: 'Community', id: string, name: string }
                  | { __typename?: 'Subdivision', id: string, name: string }
                  | { __typename?: 'Lot', id: string, name: string }
                  | { __typename?: 'Structure', id: string, name: string }
                  | { __typename?: 'Unit', id: string, name: string }
                > }> | null | undefined }
            | { __typename?: 'PlanPackage', id: string }
            | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
          , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined } | null | undefined, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, parent:
          | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string }
                | { __typename?: 'Region', id: string, name: string }
                | { __typename?: 'Market', id: string, name: string }
                | { __typename?: 'Community', id: string, name: string }
                | { __typename?: 'Subdivision', id: string, name: string }
                | { __typename?: 'Lot', id: string, name: string }
                | { __typename?: 'Structure', id: string, name: string }
                | { __typename?: 'Unit', id: string, name: string }
              > }> | null | undefined }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
        , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type SaveLienWaiverMutationVariables = Types.Exact<{
  input: Types.SaveLienWaiverInput;
}>;


export type SaveLienWaiverMutation = { __typename?: 'Mutation', saveLienWaiver: { __typename?: 'SaveLienWaiverResult', lienWaiver: { __typename?: 'LienWaiver', id: string } } };


export const LienWaiversPageDocument = gql`
    query LienWaiversPage($filter: LienWaiverFilter, $order: LienWaiverOrder, $page: PageFilter!) {
  lienWaiversPage(filter: $filter, order: $order, page: $page) {
    entities {
      ...LienWaiversPageLienWaiver
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${LienWaiversPageLienWaiverFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useLienWaiversPageQuery__
 *
 * To run a query within a React component, call `useLienWaiversPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLienWaiversPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLienWaiversPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useLienWaiversPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LienWaiversPageQuery, LienWaiversPageQueryVariables> & ({ variables: LienWaiversPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LienWaiversPageQuery, LienWaiversPageQueryVariables>(LienWaiversPageDocument, options);
      }
export function useLienWaiversPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LienWaiversPageQuery, LienWaiversPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LienWaiversPageQuery, LienWaiversPageQueryVariables>(LienWaiversPageDocument, options);
        }
// @ts-ignore
export function useLienWaiversPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LienWaiversPageQuery, LienWaiversPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LienWaiversPageQuery, LienWaiversPageQueryVariables>;
export function useLienWaiversPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LienWaiversPageQuery, LienWaiversPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LienWaiversPageQuery | undefined, LienWaiversPageQueryVariables>;
export function useLienWaiversPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LienWaiversPageQuery, LienWaiversPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LienWaiversPageQuery, LienWaiversPageQueryVariables>(LienWaiversPageDocument, options);
        }
export type LienWaiversPageQueryHookResult = ReturnType<typeof useLienWaiversPageQuery>;
export type LienWaiversPageLazyQueryHookResult = ReturnType<typeof useLienWaiversPageLazyQuery>;
export type LienWaiversPageSuspenseQueryHookResult = ReturnType<typeof useLienWaiversPageSuspenseQuery>;
export type LienWaiversPageQueryResult = ApolloReactCommon.QueryResult<LienWaiversPageQuery, LienWaiversPageQueryVariables>;
export const SaveLienWaiverDocument = gql`
    mutation SaveLienWaiver($input: SaveLienWaiverInput!) {
  saveLienWaiver(input: $input) {
    lienWaiver {
      id
    }
  }
}
    `;

/**
 * __useSaveLienWaiverMutation__
 *
 * To run a mutation, you first call `useSaveLienWaiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLienWaiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLienWaiverMutation, { data, loading, error }] = useSaveLienWaiverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLienWaiverMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLienWaiverMutation, SaveLienWaiverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLienWaiverMutation, SaveLienWaiverMutationVariables>(SaveLienWaiverDocument, options);
      }
export type SaveLienWaiverMutationHookResult = ReturnType<typeof useSaveLienWaiverMutation>;
export type SaveLienWaiverMutationResult = ApolloReactCommon.MutationResult<SaveLienWaiverMutation>;